import request from '@/libs/request';
import config from '@/config';
import RSA from '@/libs/rsa';
import md5 from 'md5';

const baseUrl = config.api_base;

// 验证邮箱
export const ValidateEmail = params => {
  return request('POST', `${baseUrl}/api/unauth/password/email`, params);
};

// 验证链接有效期
export const ValidateLink = params => {
  return request('get', `${baseUrl}/api/unauth/password/valid`, params);
};

// 重置密码
export const ResetPassword = params => {
  // 对密码进行RAS加密
  params.password = RSA.encrypt(md5(params.password));

  return request('POST', `${baseUrl}/api/unauth/password/reset`, params);
};
